module.exports = require("./jgo-CM");